import React, { useState } from 'react';
import PropTypes from 'prop-types';
import TablePagination from '@material-ui/core/TablePagination';

const Paginate = ({ currentPage, groupsPerPage, totalPosts, previousPage, nextPage, changeGroupsPerPage }) => {
  const pageNumbers = [];

  for (let i = 1; i <= Math.ceil(totalPosts / groupsPerPage); i += 1) {
    pageNumbers.push(i);
  }
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
    const pageChange = page - newPage;
    if (pageChange > 0) {
      previousPage();
    } else {
      nextPage();
    }
  };

  const handleChangeRowsPerPage = event => {
    changeGroupsPerPage(event.target.value);
    setRowsPerPage(event.target.value);
  };

  if (currentPage === page) {
    setPage(currentPage - 1);
  }

  return (
    <div className="pagination-container">
      <TablePagination
        component="div"
        count={totalPosts}
        page={page}
        onPageChange={handleChangePage}
        rowsPerPageOptions={[5, 10, 15, 20, 25]}
        labelRowsPerPage="Groups per page"
        rowsPerPage={rowsPerPage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      />
    </div>
  );
};

Paginate.propTypes = {
  currentPage: PropTypes.number.isRequired,
  groupsPerPage: PropTypes.number.isRequired,
  totalPosts: PropTypes.number.isRequired,
  previousPage: PropTypes.func.isRequired,
  nextPage: PropTypes.func.isRequired,
  changeGroupsPerPage: PropTypes.func.isRequired,
};

export default Paginate;
